var _mask, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    style: {
      transform: "rotate(40deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "moon-mask-main-nav"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 2,
    r: 8,
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    fill: "var(--color-text)",
    mask: "url(#moon-mask-main-nav)",
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 15.928203230275509,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.000000000000002,
    cy: 15.92820323027551,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 9.000000000000002,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.9999999999999964,
    cy: 2.071796769724492,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 2.0717967697244912,
    r: 1.5,
    fill: "var(--color-text)",
    style: {
      transformOrigin: "center center",
      transform: "scale(0)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.daba3b8af9c22db75526c81741c3cbc4.svg";
export { ForwardRef as ReactComponent };